"use client";

import { useUserConfig } from "@/contexts/user-config-context";

const STEP = 0.25;
const DEFAULT_SCALE = 1;
const MIN_SCALE = 0.75;
const MAX_SCALE = 2;

export function FontSizeSelector() {
  const { config, updateConfig, isLoading } = useUserConfig();
  const currentScale = config.fontSize ?? DEFAULT_SCALE;
  const isAtMin = currentScale <= MIN_SCALE;
  const isAtMax = currentScale >= MAX_SCALE;
  const isReset = currentScale === DEFAULT_SCALE;

  const apply = async (next: number) => {
    if (isLoading) return;
    const rounded = Math.round(next * 100) / 100;
    if (rounded === currentScale) return;
    try {
      await updateConfig({ fontSize: rounded });
    } catch (error) {
      console.error("Failed to update font size:", error);
    }
  };

  const decrease = () => apply(Math.max(MIN_SCALE, currentScale - STEP));
  const reset = () => apply(DEFAULT_SCALE);
  const increase = () => apply(Math.min(MAX_SCALE, currentScale + STEP));

  const pct = `${Math.round(currentScale * 100)}%`;

  return (
    <div className="flex flex-col gap-2">
      <span className="text-2xs font-bold uppercase tracking-[0.1em] text-muted-foreground-dim">
        Tamanho do texto
      </span>
      <div className="flex items-center gap-1.5">
        <button
          type="button"
          onClick={decrease}
          disabled={isAtMin || isLoading}
          aria-label="Diminuir fonte"
          className="size-9 rounded-lg bg-muted border border-border text-foreground text-base font-semibold flex items-center justify-center transition-colors hover:bg-secondary disabled:opacity-30 disabled:cursor-not-allowed"
        >
          −
        </button>
        <button
          type="button"
          onClick={reset}
          disabled={isLoading}
          className={`flex-1 h-9 rounded-lg border text-xs font-bold transition-colors ${
            !isReset
              ? "bg-primary-dim border-primary-dim-border text-primary"
              : "bg-muted border-border text-muted-foreground"
          } disabled:opacity-50`}
        >
          Reset
        </button>
        <button
          type="button"
          onClick={increase}
          disabled={isAtMax || isLoading}
          aria-label="Aumentar fonte"
          className="size-9 rounded-lg bg-muted border border-border text-foreground text-base font-semibold flex items-center justify-center transition-colors hover:bg-secondary disabled:opacity-30 disabled:cursor-not-allowed"
        >
          +
        </button>
      </div>
      <div className="font-mono text-xs font-medium text-muted-foreground text-center">
        {pct}
      </div>
    </div>
  );
}
